import { apiUtils } from '../hooks';
import { throwApiError } from '../utils';
import { API_ENDPOINTS } from './apiEndpoints';

export interface Submission {
  submissionId: string;
  submittedById: string;
  submittedAt: string;
  responsesExist: boolean;
  isLatest: boolean;
  submittedBy: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    position: string;
  };
}

export interface SubmissionData {
  hotelId: string;
  totalSubmissions: number;
  submissions: Submission[];
}
interface SubmissionResponse {
  success: true;
  message: string;
  data: SubmissionData;
}
class submissionsService {
  /**
   *
   * @param hotelId
   * @returns
   */
  static async reOpenSubmission(hotelId: string): Promise<any> {
    try {
      const response = await apiUtils.post(
        API_ENDPOINTS.hotels.reOpenSubmission(hotelId)
      );
      return response.data;
    } catch (error) {
      throwApiError(error, 'Failed to reopen submission');
    }
  }
  /**
   *
   * @param hotelId
   * @returns
   */
  static async getSubmissions(
    hotelId: string,
    isFasttrack?: boolean
  ): Promise<SubmissionResponse | null> {
    try {
      const response = await apiUtils.get<SubmissionResponse>(
        API_ENDPOINTS.hotels.submissions(hotelId, isFasttrack)
      );
      return response.data;
    } catch (error) {
      throwApiError(error, 'Failed to fetch submissions');
      return null;
    }
  }
}
export default submissionsService;
